import { useQueryClient } from '@tanstack/react-query'
import {
  useDeleteAdminsMedicationsMedicationGlobalKey,
  getGetAdminsMedicationsQueryKey,
} from '@/api/generated/medication/medication'
import type { MedicationStaffApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

export function useDeleteMedication() {
  const queryClient = useQueryClient()
  const { mutate: orvalMutate, isPending } = useDeleteAdminsMedicationsMedicationGlobalKey()

  function mutate(id: string, opts?: { onSuccess?: () => void }) {
    const listKey = getGetAdminsMedicationsQueryKey()
    const previous = queryClient.getQueryData<MedicationStaffApiOutContract[]>(listKey)

    queryClient.setQueryData<MedicationStaffApiOutContract[]>(listKey, (old) => (old ?? []).filter((m) => m.Id !== id))

    orvalMutate(
      { medicationGlobalKey: id },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: listKey })
          opts?.onSuccess?.()
        },
        onError: () => {
          queryClient.setQueryData<MedicationStaffApiOutContract[]>(listKey, previous)
        },
      },
    )
  }

  return { mutate, isPending }
}
